import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService, LoaderState } from 'src/app/service/loader.service';



@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit, OnDestroy {

  // property declaration
  show = false;
  private subscription: Subscription;

  constructor(private loaderService: LoaderService, private cdr: ChangeDetectorRef) { }

  // on initialize screen
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
        this.cdr.detectChanges();
      });
  }

  // on lost from screen
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();

    }
  }
}
